import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import Order from '../components/Order'

export default ({ location, data, pageContext }) => {
  const node = data.allContentfulPageOrder.edges[0].node
  return (
    <Layout
      pageTitle={node.pageTitle}
      location={location}
      locale={pageContext.locale}
    >
      <Order data={node} locale={pageContext.locale} />
    </Layout>
  )
}

export const orderQuery = graphql`
  query($locale: String) {
    allContentfulPageOrder(filter: { node_locale: { eq: $locale } }) {
      edges {
        node {
          pageTitle
          startText {
            childMarkdownRemark {
              html
            }
          }
          storyTextPlaceholder
          commentsPlaceholder
          cardTextPlaceholder
          courierNotePlaceholder
          validation {
            inaccessibleLocationValidationMessage
            urgentDeliveryMessage
            moreThan24hValidationMessage
            dateInFutureValidationMessage
            sundayValidationMessage
            vacationValidationMessage
            vacationDays
            eveningDeliveryMessage
          }
        }
      }
    }
  }
`
